// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-dialog {
  position: absolute;
  top: 0;
  margin-top: 20px;
  right: 0;
  margin-right: 20px;
  height: 24px;
  width: 24px;
  background-image: url('hover-x.51d99dd21ec0e20c.svg');
  background-position: 99% 3%;
  background-repeat: no-repeat;
}
.close-dialog:hover {
  background-image: url('unselected-x.94f7db39b7176d24.svg');
  cursor: pointer;
}
::ng-deep mat-dialog-container {
  overflow: visible !important;
}
::ng-deep mat-dialog-content.mat-dialog-content {
  overflow: visible !important;
}
.modal-dialog {
  min-height: 200px;
  width: 600px;
  padding: 20px;
  background-color: #ffffff;
  border: 3px solid #7F6C2E;
  display: block;
  margin-bottom: 0;
}
.modal-dialog.dialog-sml {
  width: 400px;
}
.modal-dialog.dialog-lrg {
  width: 775px;
}
.modal-dialog.dialog-xlrg {
  width: 975px;
}
.modal-dialog .default > div {
  position: relative;
  padding: 5px 15px;
}
.modal-dialog h2 {
  margin-top: 0;
  margin-bottom: 10px;
}
.modal-dialog .modal-body {
  margin-bottom: 10px;
  padding: 15px;
}
.modal-dialog .modal-body.scrollable {
  max-height: 500px;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
}
.modal-dialog .dialog-buttons {
  text-align: right;
  justify-content: flex-end;
  margin-bottom: 5px;
  width: 100%;
}
.modal-dialog .dialog-buttons button {
  text-align: center;
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/oir-dialog/oir-dialog.component.less"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,MAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qDAAA;EACA,2BAAA;EACA,4BAAA;AADF;AAGE;EACE,0DAAA;EACA,eAAA;AADJ;AAKA;EACE,4BAAA;AAHF;AAMA;EACE,4BAAA;AAJF;AAOA;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AALF;AAOE;EACE,YAAA;AALJ;AAQE;EACE,YAAA;AANJ;AASE;EACE,YAAA;AAPJ;AAXA;EAuBM,kBAAA;EACA,iBAAA;AATN;AAfA;EA6BI,aAAA;EACA,mBAAA;AAXJ;AAnBA;EAkCI,mBAAA;EACA,aAAA;AAZJ;AAcI;EACE,iBAAA;EACA,6BAAA;EACA,6BAAA;AAZN;AA5BA;EA6CI,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AAdJ;AAlCA;EAmDM,kBAAA;EACA,iBAAA;AAdN","sourcesContent":["@import (reference) '../../styles/variables.less';\n\n.close-dialog {\n  position: absolute;\n  top: 0;\n  margin-top: 20px;\n  right: 0;\n  margin-right: 20px;\n  height: 24px;\n  width: 24px;\n  background-image: url(../../styles/img/hover-x.svg);\n  background-position: 99% 3%;\n  background-repeat: no-repeat;\n\n  &:hover {\n    background-image: url(../../styles/img/unselected-x.svg);\n    cursor: pointer;\n  }\n}\n\n::ng-deep mat-dialog-container {\n  overflow: visible !important;\n}\n\n::ng-deep mat-dialog-content.mat-dialog-content {\n  overflow: visible !important;\n}\n\n.modal-dialog {\n  min-height: 200px;\n  width: 600px;\n  padding: 20px;\n  background-color: @white;\n  border: 3px solid @primary-base;\n  display: block;\n  margin-bottom: 0;\n\n  &.dialog-sml {\n    width: 400px;\n  }\n\n  &.dialog-lrg {\n    width: 775px;\n  }\n\n  &.dialog-xlrg {\n    width: 975px;\n  }\n\n  .default {\n    > div {\n      position: relative;\n      padding: 5px 15px;\n    }\n  }\n\n  h2 {\n    margin-top: 0;\n    margin-bottom: 10px;\n  }\n\n  .modal-body {\n    margin-bottom: 10px;\n    padding: 15px;\n\n    &.scrollable {\n      max-height: 500px;\n      overflow-y: scroll !important;\n      overflow-x: hidden !important;\n    }\n  }\n\n  .dialog-buttons {\n    text-align: right;\n    justify-content: flex-end;\n    margin-bottom: 5px;\n    width: 100%;\n\n    button {\n      text-align: center;\n      margin-left: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
